import { Button } from 'antd';

import Message from './Message';
import ArrowClockwise from '../icons/ArrowClockwise';

type StateMessageProps = {
  loading?: boolean | string;
  type?: Parameters<typeof Message>[0]['type'];
  error?: boolean | string;
  children: React.ReactNode;
  onRetry?: () => void;
};

const StateMessage = ({ loading, error, children, onRetry, type }: StateMessageProps) => {
  if (error) {
    return (
      <div className='w-full'>
        <Message type='error'>{typeof error === 'string' ? error : 'Algo deu errado'}</Message>{' '}
        {onRetry && (
          <Button
            className='mt-0! h-auto! w-fit! rounded-lg! py-1!'
            id='message-try-again-button'
            size='small'
            type='default'
            onClick={onRetry}
            icon={
              <div className='flex items-center'>
                <ArrowClockwise className='h-4 w-4' />
              </div>
            }
          >
            Tentar novamente
          </Button>
        )}
      </div>
    );
  }

  if (loading) {
    return <Message type={type || 'ai'}>{typeof loading === 'string' ? loading : 'Pensando...'}</Message>;
  }

  return <Message type={type || 'ai'}>{children}</Message>;
};

export default StateMessage;
